import Modal from 'LuxKit/Modal/Modal'
import React from 'react'
import CFMRUnforseenEventsModalContent from './CFMRUnforseenEventsModalContent'

interface Props {
  quote?: App.InsuranceQuote
}

function CFMRUnforseenEventsModal({ quote }: Props) {
  return <Modal
    title="Cancellation policy"
    subtitle="This exclusive protection from Luxury Escapes and XCover ensures a hassle-free 100% refund if you need to cancel for unforeseen events."
  >
    <CFMRUnforseenEventsModalContent quote={quote} />
  </Modal>
}

export default CFMRUnforseenEventsModal
